import React from 'react';
import { connect } from 'react-redux';
import { declOfNum } from '@ertelecom/ui-react/components/helpers';
import InterestingBlock from '@ertelecom/ui-react/components/blocks/interestingBlocks';
import { GA } from '~/src/api/channels';
import TarifChannels from '~/src/components/Channels/tarifChannels';
import CardCanConnect from '~/src/components/Channels/cardCanConnect';
import PopupPackage from '~/src/components/Channels/popupPackage';
import PopupChannels from '~/src/components/Channels/popupChannels';
import SubscribeControl from '~/src/components/Channels/subscribeControl';
import ResumptionControl from '~/src/components/Channels/resumptionControl';
import PackageChannelList from '~/src/components/Channels/packageChannelList';
import FormConnect from '~/src/components/Channels/formConnect';
import { data } from '~/src/components/DomRuTv/data';
import Banner from '~/src/components/Channels/banner/index';
import {
    Wrapper,
    TitleAdditionalChannels,
    TitleCanConnect,
    WrapperChannel,
    CardChannelGrid,
    CanConnectGrid,
    CanConnectItem,
} from './styled';
// comment
const channelsText = declOfNum(['канал', 'канала', 'каналов']);

class DomruChannelsAuth extends React.Component {
    state = {
        canConnect: [],
        connectedInTariff: [],
        connectedOutTariff: [],
        connectedChannels: [],
        channelsCountInTariff: {},
        terminalId: -1,
        popupControl: {
            open: false,
            data: {},
        },
        popupChannel: {
            open: false,
            index: 0,
            text: '',
        },
        popupConnect: {
            isShow: false,
            data: {},
        },
        popupChannels: {
            isShow: false,
        },
        popupResumption: {
            open: false,
            data: {},
        },
        bannerInfo: {}
    }

    componentDidMount() {
        this.loadData();
        this.getBannerInfo();
    }

    getBannerInfo = () => {
        const { bannerInfo } = this.props;

        this.setState({
            bannerInfo: bannerInfo?.items[0],
        });
    }

    getUnique = (data) => {
        const uniqueArray = data.filter((item1, pos, self) => self.findIndex((item2) => item2.chid === item1.chid) === pos);
        return uniqueArray;
    }

    loadData = () => {
        const { tvPackets } = this.props;
        let channelsInPackets = [];
        let connectedChannels = [];
        if (tvPackets !== undefined) {
            const notHasProlong = [];
            channelsInPackets = tvPackets.connectedInTariff.map(item => item.channels);
            const allChannels = channelsInPackets.flatMap(item => item);
            connectedChannels = this.getUnique(allChannels);
            let hasProlong = [];
            if (tvPackets.canConnect && tvPackets.canConnect.length > 0) {
                hasProlong = tvPackets.canConnect.filter((item) => {
                    if (item.state.prolong === 1) {
 return item.state.prolong === 1;
}
                    notHasProlong.push(item);
                    return false;
                });
            }
            const outTariff = (tvPackets.connectedOutTariff || []).concat(hasProlong);
            this.setState({
                canConnect: notHasProlong,
                connectedChannels: connectedChannels,
                channelsCountInTariff: tvPackets.channelsCountInTariff || {},
                connectedInTariff: tvPackets.connectedInTariff[0] || {},
                connectedOutTariff: outTariff,
                terminalId: tvPackets.terminalId,
            });
        }
    }

    onOtherChannelCardClick = (id, cost, duration) => {
        const { canConnect } = this.state;
        const channel = canConnect.find(el => el.id === id);
        if (channel === undefined) {
 return;
}

        GA({
            action: 'click on connect the channels btn',
            label: `${channel.name}, ${(cost === channel.baseCost) ? 'базовая цена' : `подписка на ${duration} мес`}`,
        });

        this.setState((state) => ({
            ...state,
            popupConnect: {
                isShow: true,
                data: {
                    cost,
                    duration,
                    channel,
                    terminalId: this.state.terminalId,
                },
            },
        }));
    }

    onClickTariffChannels = () => {
        GA({
            action: 'look at channels',
            label: this.props.tarifName,
        });

        this.setState({
            popupChannels: {
                isShow: true,
            },
        });
    }

    onClosePopupConnect = () => {
        this.setState((state) => ({
            ...state,
            popupConnect: {
                ...state.popupConnect,
                isShow: false,
            },
        }));
    }

    onClosePopupChannels = () => {
        this.setState((state) => ({
            ...state,
            popupChannels: {
                ...state.popupChannels,
                isShow: false,
            },
        }));
    }

    onClickConnectedPackageChannels = (bundle) => {
        if (!bundle) {
 return;
}

        GA({
            action: 'look at channels',
            label: bundle.name,
        });

        this.setState({
            popupChannel: {
                open: true,
                data: bundle,
                text: `${bundle.channelsCount} ${channelsText(bundle.channelsCount)} ${bundle.channelsCount === 1 ? 'входит ' : 'входят '} в пакет`,
            },
        });
    }

    onClickSubscribeControl = (item) => {
        GA({
            action: 'subscription management',
            label: item.name,
        });
        this.setState({
            popupControl: {
                open: true, data: {
                    ...item,
                    terminalId: this.state.terminalId,
                }
            }
        });
    }

    onClickSubscribeControlDisconnect = (item) => {
        this.setState({
            popupControl: {
                open: true, data: {
                    ...item,
                    terminalId: this.state.terminalId,
                    action: 'off',
                }
            }
        });
    }

    onClickResumption = (item) => {
        this.setState({
            popupResumption: {
                open: true, data: {
                    ...item,
                    terminalId: this.state.terminalId,
                }
            }
        });
    }

    // массив с карточками может разделиться на две части - вынесено в отдельный метод
    mapCard = (arr) => {
        return arr.map((element) =>
            <CardCanConnect
                key={element.id}
                id={element.id}
                items={element.channels}
                baseCost={element.baseCost}
                costRa={element.costRa}
                color={element.color}
                title={element.name}
                subtitle={`${element.channelsCount} ${channelsText(element.channelsCount)} (${element.channelsCountHd}HD)`}
                logoNoBackground={element.logoNoBackground}
                onButtonClick={this.onOtherChannelCardClick}
            />);
    }

    // добавление баннера в карточки пакетов
    fillArray = (items, arrayToPush) => {
        const banner = <Banner bannerInfo={this.state.bannerInfo} />;
        for (let i = 0; i < items.length; i++) {
            if (items[i].props.items.length > 0) {
                arrayToPush.push(items[i]);
                if (arrayToPush.length === 2) {
 arrayToPush.push(banner);
}
            }
        }
        if (arrayToPush.length < 2) {
 arrayToPush.push(banner);
}
    }


    renderCardToConnect = (cardArr) => {
        const elements = [];
        this.fillArray(this.mapCard(cardArr), elements);

        return elements.map((element, index) => (
            <CanConnectItem key={index}>
                {element}
            </CanConnectItem>
        ));
    }

    render() {
        const { connectedInTariff, connectedOutTariff, canConnect, popupConnect, popupChannels, terminalId, channelsCountInTariff, connectedChannels } = this.state;
        return (
            <React.Fragment>
                <Wrapper>
                    {channelsCountInTariff.total > 0 && <TarifChannels text={`В вашем тарифе ${channelsCountInTariff.total} ${channelsText(channelsCountInTariff.total)}`} onButtonClick={this.onClickTariffChannels} />}
                    {
                        connectedOutTariff.length > 0 && (
                            <React.Fragment>
                                <TitleAdditionalChannels>Каналы, подключенные дополнительно</TitleAdditionalChannels>
                                <WrapperChannel>
                                    {
                                        connectedOutTariff.map((item) => (<CardChannelGrid
                                            key={item.name}
                                            title={item.name}
                                            cost={item.cost}
                                            dateOff={item.state.dateOff}
                                            color={item.color}
                                            channels={`${item.channelsCount} ${channelsText(item.channelsCount)}`}
                                            state={item.state}
                                            onSubscribeClick={() => {
                                                this.onClickSubscribeControl(item);
                                            }}
                                            onChannelClick={() => {
                                                this.onClickConnectedPackageChannels(item);
                                            }}
                                            onDisconnectClick={() => {
                                                this.onClickSubscribeControlDisconnect(item);
                                            }}
                                            onClickResumption={() => {
                                                this.onClickResumption(item);
                                            }}
                                        />))
                                    }
                                </WrapperChannel>
                            </React.Fragment>
                        )
                    }
                    {// костыль для проверки, ответила ли уже апишка
                        terminalId !== -1 && <React.Fragment>
                            <TitleCanConnect>Можете себе подключить</TitleCanConnect>
                            <CanConnectGrid>
                                {this.renderCardToConnect(canConnect)}
                            </CanConnectGrid>
                        </React.Fragment>
                    }

                    <InterestingBlock
                        list={data}
                        blocksTitle='Вам может быть интересно'
                    />

                </Wrapper>

                <PopupPackage
                    onClose={this.onClosePopupConnect}
                    isOpen={popupConnect.isShow}
                    text={'Подключение пакета каналов'}
                    {...popupConnect.data.channel}
                >
                    {popupConnect.data.channel && <FormConnect onSuccess={this.loadData} onClose={this.onClosePopupConnect} data={popupConnect.data} />}
                </PopupPackage>

                {channelsCountInTariff && <PopupChannels
                    channelInfo={channelsCountInTariff}
                    connectedChannels={connectedChannels}
                    data={connectedInTariff}
                    isOpen={popupChannels.isShow}
                    onClose={this.onClosePopupChannels}
                />}

                <PopupPackage
                    onClose={() => this.setState({ popupControl: { open: false } })}
                    isOpen={this.state.popupControl.open}
                    text='Управление подпиской'
                    {...this.state.popupControl.data}
                >
                    <SubscribeControl
                        onSuccess={this.loadData}
                        onClose={() => this.setState({ popupControl: { open: false } })}
                        data={this.state.popupControl.data}
                    />
                </PopupPackage>

                <PopupPackage
                    onClose={() => this.setState({ popupResumption: { open: false } })}
                    isOpen={this.state.popupResumption.open}
                    text='Управление подпиской'
                    {...this.state.popupResumption.data}
                >
                    <ResumptionControl
                        onSuccess={this.loadData}
                        onClose={() => this.setState({ popupResumption: { open: false } })}
                        data={this.state.popupResumption.data}
                    />
                </PopupPackage>

                <PopupPackage
                    onClose={() => this.setState({ popupChannel: { open: false } })}
                    isOpen={this.state.popupChannel.open}
                    text={this.state.popupChannel.text}
                    {...this.state.popupChannel.data}
                >
                    {this.state.popupChannel.data && <PackageChannelList items={this.state.popupChannel.data.channels} />}
                </PopupPackage>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
    tarifName: state.auth.clientProducts.tariffName,
    accessToken: state.auth.accessToken,
    billingDomain: state.auth.billingDomain
});

export default connect(
    mapStateToProps,
)(DomruChannelsAuth);
